// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1wzby","col":"styles_col__1kDPK"};